<template>
  <v-chip
    label
    size="small"
    class="text-white"
    :color="status === 'Active' ? 'green' : 'grey'"
  >
    {{ status === 'Pending' ? 'Listing Pending' : status }}
  </v-chip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'AvailabilityStatusChip',

  props: {
    status: {
      type: String,
      required: true
    },
  },
});
</script>
